import { render, staticRenderFns } from "./boardEightItem.vue?vue&type=template&id=6b433e76&scoped=true"
import script from "./boardEightItem.vue?vue&type=script&lang=js"
export * from "./boardEightItem.vue?vue&type=script&lang=js"
import style0 from "./boardEightItem.vue?vue&type=style&index=0&id=6b433e76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b433e76",
  null
  
)

export default component.exports